import script from "./UserCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserCreate.vue?vue&type=script&lang=ts&setup=true"

import "./UserCreate.vue?vue&type=style&index=0&id=2b13b305&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b13b305"]])

export default __exports__